import styled from '@emotion/styled'
import { ConsentLevel, useConsentGiven } from '@news-mono/web-common'
import React from 'react'
import { ConsentFallback } from '../../../tracking/ConsentFallback/ConsentFallback'

export interface DatawrapperProps {
    link: string
}

export const isDatawrapper = (link: string) => {
    return link.indexOf('datawrapper.dwcdn.net') >= 0
}

export const datamapperUrlParts = (link: string) => {
    const parsed = link.split('/')

    return {
        id: parsed[3],
        version: parsed[4],
    }
}

function dataWrapperListener(event: any) {
    if (typeof event.data['datawrapper-height'] !== 'undefined') {
        const iframes = document.querySelectorAll('iframe')
        for (const chartId in event.data['datawrapper-height']) {
            for (let i = 0; i < iframes.length; i++) {
                if (iframes[i].contentWindow === event.source) {
                    const iframe = iframes[i]
                    iframe.style.height =
                        event.data['datawrapper-height'][chartId] + 'px'
                }
            }
        }
    }
}

const DatawrapperWithConsent: React.FC<{
    link: string
    chartId: string
    chartVersion: string
}> = ({ link, chartId, chartVersion }) => {
    const ref = React.useRef<HTMLIFrameElement>(null)

    React.useEffect(() => {
        // Datamapper's listener for responsive widgets
        window.addEventListener('message', dataWrapperListener)

        return function cleanupListener() {
            window.removeEventListener('message', dataWrapperListener)
        }
    }, [link])

    return (
        <StyledIframe
            ref={ref}
            aria-label="Datawrapper Chart"
            id={`datawrapper-chart-${chartId}`}
            src={`https://datawrapper.dwcdn.net/${chartId}/${chartVersion}/`}
            scrolling="no"
            frameBorder="0"
            height="360" // iframe is resized to proper size after widget has loaded
        />
    )
}

export const DatawrapperEmbed: React.FC<DatawrapperProps> = ({ link }) => {
    const consentGiven = useConsentGiven({
        consentRequiredLevel: ConsentLevel.Analytics | ConsentLevel.Advertising,
    })

    if (!consentGiven) {
        return <ConsentFallback />
    }

    const chartParts = datamapperUrlParts(link)

    return (
        <DatawrapperWithConsent
            link={link}
            chartId={chartParts.id}
            chartVersion={chartParts.version}
        />
    )
}

const StyledIframe = styled('iframe')(() => ({
    width: 0,
    minWidth: '100% !important',
    border: 'none',
}))
